var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeepBreathingInactive(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23 15.478C23 13.565 21.815 4 16.928 4c-2.074 0-1.926 5.333-1.926 8.043 0 4.522.887 7.957 5.925 7.957C22.704 20 23 17.391 23 15.478Zm-22 0C1 13.565 2.185 4 7.072 4c2.074 0 1.926 5.333 1.926 8.043C8.998 16.566 8.11 20 3.073 20 1.296 20 1 17.391 1 15.478Z",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18 11h-.5A5.5 5.5 0 0 1 12 5.5V1M6 11h.5A5.5 5.5 0 0 0 12 5.5V1",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeepBreathingInactive);
export default __webpack_public_path__ + "static/media/deep-breathing-inactive.7cf24c10589519f8f380386e751d2163.svg";
export { ForwardRef as ReactComponent };